/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'navigation/in-black': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><path pid="0" _fill="#fff" d="M0 0h34v34H0z"/><path pid="1" d="M18.6 15.63l4.06 4.28H25l-3.3-3.42H29v-1.72h-7.3l3.3-3.43h-2.34z" _fill="#151716"/><path pid="2" d="M21.58 20.14v4.4H14v4.52l-9-4.52V4.94h16.58v6.4h-1.51V6.45H8l6 3V23h6v-2.86z" _fill="#151716"/></g></g>'
  }
})
